module.exports = __webpack_public_path__ + "static/media/developer.d474e3f7.svg";